import { Box } from '@mui/material';
import Color from 'color';
import type { Header } from '@tanstack/react-table';
import { useTableState } from '../../providers/TableStateProvider';

const TableColumnResizer = ({
  header,
}: {
  header: Header<unknown, unknown>;
}) => {
  const tableState = useTableState();

  return (
    <Box
      component="div"
      onMouseDown={header.getResizeHandler()}
      onClick={(e: any) => e.stopPropagation()}
      sx={{
        transform: header.column.getIsResizing()
          ? `translateX(${
              getResizingTranslation(
                tableState.table.options.columnResizeDirection
              ) *
              (tableState.table.getState().columnSizingInfo.deltaOffset ?? 0)
            }px)`
          : '',
        right: 0,
        position: 'absolute',
        top: '15%',
        height: '75%',
        width: 2,
        background: (theme) =>
          theme.palette.mode === 'light'
            ? Color(theme.palette.background.active).darken(0.1).string()
            : theme.palette.background.active,
        cursor: 'col-resize',
        userSelect: 'none',
        touchAction: 'none',
        zIndex: 100,
        ...(header.column.getIsResizing() && {
          background: (theme) =>
            Color(theme.palette.background.active).darken(0.35).string(),
        }),
      }}
    />
  );
};

export default TableColumnResizer;

function getResizingTranslation(direction: string | undefined) {
  if (direction === 'rtl') {
    return -1;
  }

  return 1;
}
